"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const QueryBuilderContext_1 = require("../QueryBuilderContext");
const lab_1 = require("@material-ui/lab");
const core_1 = require("@material-ui/core");
const QueryBuilderPluginPicker = (_a) => {
    var { value, disabled, error, helperText, onChange, fullWidth, disableClearable, placeholder = 'Select a plugin' } = _a, props = __rest(_a, ["value", "disabled", "error", "helperText", "onChange", "fullWidth", "disableClearable", "placeholder"]);
    const { plugins } = (0, QueryBuilderContext_1.useQueryBuilderContext)();
    const filteredPlugins = (0, react_1.useMemo)(() => plugins.filter(p => !p.default), [plugins]);
    const selected = plugins === null || plugins === void 0 ? void 0 : plugins.find(plugin => {
        return value && [plugin.type, plugin.name].includes(value);
    });
    return (react_1.default.createElement(lab_1.Autocomplete, { disableClearable: disableClearable, fullWidth: fullWidth, forcePopupIcon: true, disabled: disabled, value: selected || null, options: filteredPlugins || [], getOptionLabel: option => option.name, onChange: (_, value) => onChange === null || onChange === void 0 ? void 0 : onChange(value || undefined), renderInput: params => (react_1.default.createElement(core_1.TextField, Object.assign({}, params, { fullWidth: true, size: 'small', variant: 'outlined', placeholder: placeholder, error: error, helperText: helperText }, props, { InputProps: Object.assign(Object.assign({}, params.InputProps), props.InputProps) }))) }));
};
exports.default = QueryBuilderPluginPicker;
//# sourceMappingURL=QueryBuilderPluginPicker.js.map